/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_SkillsInputs */

const en_rd_fix_skills = /** @type {(inputs: Rd_Fix_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add .claude/skills/<name>/SKILL.md for the repeatable jobs your agent keeps redoing.`)
};

const id_rd_fix_skills = /** @type {(inputs: Rd_Fix_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan .claude/skills/<nama>/SKILL.md untuk pekerjaan berulang yang itu-itu saja.`)
};

/**
* | output |
* | --- |
* | "Add .claude/skills/<name>/SKILL.md for the repeatable jobs your agent keeps redoing." |
*
* @param {Rd_Fix_SkillsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_skills = /** @type {((inputs?: Rd_Fix_SkillsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_SkillsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_skills(inputs)
	return en_rd_fix_skills(inputs)
});